var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordtick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(0 -69.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13459",
    "data-name": "Group 13459",
    transform: "translate(0 69.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38047",
    "data-name": "Path 38047",
    d: "M18.786,69.957a.724.724,0,0,0-1.033,0l-11.846,12L1.248,77.235a.724.724,0,0,0-1.033,0,.747.747,0,0,0,0,1.047l5.176,5.242a.724.724,0,0,0,1.033,0L18.786,71A.747.747,0,0,0,18.786,69.957Z",
    transform: "translate(0 -69.741)",
    fill: "#58a300"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordtick);
export default __webpack_public_path__ + "static/media/Record tick.b7a59872.svg";
export { ForwardRef as ReactComponent };